// extracted by mini-css-extract-plugin
export var badgeStyle = "VA2h0";
export var hideCountStyle = "Mv28L";